export const defaults = {
  isLoggedIn: Boolean(localStorage.getItem("accessToken")) || false,
};

export const resolvers = {
  Mutation: {
    logUserIn: (_, { token }, { cache }) => {
      localStorage.setItem("accessToken", token);
      cache.writeData({
        data: {
          isLoggedIn: true,
        },
      });
      return null;
    },
    logUserOut: (_, __, { cache }) => {
      localStorage.removeItem("accessToken");
      window.location = "/";
      return null;
    },
  },
};
